import { Component, Input, OnInit } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { IdentityBrandingService } from 'src/app/services/identityBranding.service';
import { EmailPreviewDialogComponent, EmailPreviewModalOptions } from '../../../requestbuilder/email-preview-dialog/email-preview-dialog.component';
import { TranslateService } from '@ngx-translate/core';
import { lastValueFrom } from 'rxjs';
import { LoggingService } from 'src/app/services/logging.service';
import { DomSanitizer } from '@angular/platform-browser';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  templateUrl: './branding-tab-email.component.html',
  styleUrls: ['./branding-tab-email.component.css']
})
export class BrandingTabEmailComponent implements OnInit {

  translations:any = <any>{};
  alignment: string = 'Left';
  advancedEmailMode: boolean = false;
  email: any;
  emailHeader!: string;
  emailFooter!: string;
  advancedEmail: boolean = false;
  emailLogo: File|null = null;
  emailLogoName: string|null = null;
  emailLogoBase64: string|null = null;
  resetEmailLogo: boolean = false;
  brandingChanged: boolean = false;

  @Input('user') user!: any;

  constructor(protected brandingService: IdentityBrandingService, protected toastService: ToastService, protected modalService: NgbModal, protected translateService: TranslateService, protected loggingService: LoggingService, protected sanitizer: DomSanitizer) {
    this.getTranslations();
    translateService.onLangChange.subscribe(() => {
      this.getTranslations();
    });
   }

  ngOnInit(): void {
    //May not been empty;
  }

  getTranslations() {
    this.translateService.get([
      'Settings.OrganisationBrandingSection.EmailTemplate.From',
      'Settings.OrganisationBrandingSection.EmailTemplate.To',
      'Settings.OrganisationBrandingSection.EmailTemplate.Subject',
      'Settings.OrganisationBrandingSection.EmailTemplate.SubjectValue',
      'Settings.OrganisationBrandingSection.EmailTemplate.ValidUntil',
      'Settings.OrganisationBrandingSection.EmailTemplate.Sign',
      'Settings.OrganisationBrandingSection.EmailTemplate.DocumentName',
      'Settings.OrganisationBrandingSection.EmailTemplate.GoToDocument',
      'Settings.OrganisationBrandingSection.EmailTemplate.CopyUrl',
      'Settings.OrganisationBrandingSection.EmailTemplate.ErrorSettingLogo',
      'Toasts.ImageSizeToBig',
      'Toasts.InvalidImageType',
      'Toasts.Error',
      'Toasts.Saved',
      'Toasts.Sent',
      'Toasts.TestEmailSuccessfullySent',
	    'Toasts.ChangesSaved',
      "Toasts.Success"
    ]).subscribe(translation => {
      this.translations.emailTemplateFrom = translation['Settings.OrganisationBrandingSection.EmailTemplate.From'];
      this.translations.emailTemplateTo = translation['Settings.OrganisationBrandingSection.EmailTemplate.To'];
      this.translations.emailTemplateSubject = translation['Settings.OrganisationBrandingSection.EmailTemplate.Subject'];
      this.translations.emailTemplateSubjectValue = translation['Settings.OrganisationBrandingSection.EmailTemplate.SubjectValue'];
      this.translations.emailTemplateValidUntil = translation['Settings.OrganisationBrandingSection.EmailTemplate.ValidUntil'];
      this.translations.emailTemplateSign = translation['Settings.OrganisationBrandingSection.EmailTemplate.Sign'];
      this.translations.emailTemplateDocumentName = translation['Settings.OrganisationBrandingSection.EmailTemplate.DocumentName'];
      this.translations.emailTemplateGoToDocument = translation['Settings.OrganisationBrandingSection.EmailTemplate.GoToDocument'];
      this.translations.emailTemplateCopyUrl = translation['Settings.OrganisationBrandingSection.EmailTemplate.CopyUrl'];
      this.translations.toastsEmailTemplateErrorSettingLogo = translation['Settings.OrganisationBrandingSection.EmailTemplate.ErrorSettingLogo'];
      this.translations.toastsImageSizeToBig = translation['Toasts.ImageSizeToBig'];
      this.translations.toastsInvalidImageType = translation['Toasts.InvalidImageType'];
      this.translations.error = translation['Toasts.Error'];
      this.translations.sent = translation['Toasts.Sent'];
      this.translations.testEmailSuccessfullySent = translation['Toasts.TestEmailSuccessfullySent'];
      this.translations.toastSaved = translation['Toasts.Saved'];
      this.translations.toastChangedSaved = translation['Toasts.ChangesSaved'];
      this.translations.success = translation['Toasts.Success'];
    });
  }

  uploadImage(event: any) {
    let error = this.setImageAsBase64(event);
    if(!error){
      this.emailLogo = event.target.files[0];
      this.emailLogoName = event.target.files[0].name;
      this.resetEmailLogo = false;
      this.email.emailLogo = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(event.target.files[0]));
    }
  }

  setImageAsBase64(event: any) {
    let y = this;
    let reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    let name = (event.target.files[0].name).toLowerCase();
    let lastDot = name.lastIndexOf('.');
    let ext = name.substring(lastDot + 1);
    if((event.target.files[0].size / 1024) < 100) {
      if(ext == 'png' || ext == 'jpg' || ext == 'jpeg' || ext == 'gif' || ext == 'bmp') {
        reader.onload = function () {
          y.emailLogoBase64 = reader.result!.toString();
          y.email.emailLogoUrl = y.emailLogoBase64;
        }
        return false;
      } else {
        this.toastService.showError("" + this.translations.error + "", "" + this.translations.toastsInvalidImageType + "");
        return true;
      } 
    } else {
      this.toastService.showError("" + this.translations.error + "", "" + this.translations.toastsImageSizeToBig + "");
      return true;
    }
  }


  updateSimpleValues(key:string, event:any){
    this.email[key] = (event.target as HTMLInputElement).value;
  }

  updateAdvancedValues(key:string, event:any){
    this.email[key] = (event.target as HTMLInputElement).value;
  }

  async updateSimpleEmail(){
    await this.saveImage();
  }

  openEmailPreview(email:string) {
    const modalRef = this.modalService.open(EmailPreviewDialogComponent, EmailPreviewModalOptions);
    modalRef.componentInstance.emailTemplate = email;
  }
  
  sendTestEmail(){}
  enableAdvancedEmailMode(event: any) {}
  updateAdvancedEmail(){}
  removeImage() {}
  async openSimpleEmailPreview(){}
  async openAdvancedEmailPreview() {}
  protected async saveImage() {}

}

@Component({
  selector: 'app-branding-tab-email-organisation',
  templateUrl: './branding-tab-email.component.html'
})
export class BrandingTabEmailOrganisationComponent extends BrandingTabEmailComponent {

  private _organisation!: any;
  get organisation(): any {
    return this._organisation;
  }
  @Input('organisation') set organisation(val: any){
    this._organisation = val;
    if(this._organisation){
      this.getEmail();
    }
  }
  constructor(protected override brandingService: IdentityBrandingService, protected override toastService: ToastService, protected override modalService: NgbModal, protected override translateService: TranslateService, protected override loggingService: LoggingService, protected override sanitizer: DomSanitizer) {
    super(brandingService, toastService, modalService, translateService, loggingService, sanitizer)
  }

  private getEmail() {
    this.brandingService.getEmailOrganisation(this.organisation.guid)
      .then(value => {
        lastValueFrom(value).then((result: any) => {
          this.email = result;
          this.advancedEmailMode = JSON.parse(result.emailAdvancedMode) ?? false;
          this.email.EmailAdvancedMode = this.advancedEmailMode;
          this.email.emailLogo = result.emailLogoUrl;
          if(!this.email.emailAlignment) this.email.emailAlignment = "Left"
        }).catch((error) => this.loggingService.logException(error));
      })
      .catch((error) => this.loggingService.logException(error));
  }

  protected override async saveImage() {
    const uploadData = new FormData();
    if(this.emailLogo !== null) uploadData.append('EmailLogo', this.emailLogo, this.emailLogoName!);
    uploadData.append('ResetEmailLogo', this.resetEmailLogo.toString());
    this.brandingService.postBrandingOrganisation(this.organisation.guid, uploadData)
    .then(data => {
      lastValueFrom(data).then(async () => {
        this.resetEmailLogo = false;
        this.emailLogo = null;
        await this.updateEmail();
      })
      .catch(() => {
        this.toastService.showError("" + this.translations.error + "", "" + this.translations.toastsEmailTemplateErrorSettingLogo + "");
      });
    })
    .catch(error => this.loggingService.logException(error));
  }

  override removeImage() {
    this.emailLogoName = null;
    this.email.emailLogoUrl = null;
    this.resetEmailLogo = true;
    this.emailLogo = null;
    this.brandingChanged = true;
    const uploadData = new FormData();
    uploadData.append('ResetEmailLogo', this.resetEmailLogo.toString());
    this.brandingService.postBrandingOrganisation(this.organisation.guid, uploadData)
    .then(data => {
      lastValueFrom(data).then(() => {
        this.resetEmailLogo = false;
        this.brandingChanged = false;
        this.emailLogo = null;
        this.toastService.showSuccess(this.translations.toastSaved, this.translations.toastChangedSaved);
        this.getEmail();
      })
      .catch(() => {
        this.toastService.showError("" + this.translations.error + "", "" + this.translations.toastsErrorDeletingBranding + "");
      });
    });
  }

  private async updateEmail(){
    this.brandingService.postEmailOrganisation(this._organisation.guid, this.email)
      .then(value => lastValueFrom(value).then(() => {
        this.toastService.showSuccess(this.translations.toastSaved, this.translations.toastChangedSaved);
        this.getEmail();
      }).catch((error) => this.loggingService.logException(error)))
      .catch((error) => this.loggingService.logException(error));
  }

  override async updateAdvancedEmail(){
    this.brandingService.postEmailOrganisation(this._organisation.guid,this.email)
      .then(value => lastValueFrom(value).then(() => {
        this.toastService.showSuccess(this.translations.toastSaved, this.translations.toastChangedSaved);
        this.getEmail();
      }).catch((error) => this.loggingService.logException(error)))
      .catch((error) => this.loggingService.logException(error));
  }

  override sendTestEmail(){
    this.brandingService.sendTestEmailOrganisation(this._organisation.guid, this.email)
    .then(value => 
      lastValueFrom(value))
      .then(() => {
        this.toastService.showSuccess(this.translations.success, this.translations.testEmailSuccessfullySent + " " + this.user.email);
      })
    .catch((error) => this.loggingService.logException(error));
  }
  
  override async openAdvancedEmailPreview() {
    let y = this;
    await this.brandingService.generateEmailOrganisation(this.organisation.guid, this.email)
    .then(data => {
      lastValueFrom(data).then(async (template: string) => {
        let emailbody = template.substring(template.indexOf("[[BodyStart]]") + 13, template.lastIndexOf("[[BodyEnd]]"));
        template = this.email.emailHeader + emailbody + this.email.emailFooter;
        await y.openEmailPreview(template);
      })
        .catch(error => this.loggingService.logException(error));
      })
    .catch(error => this.loggingService.logException(error));
  }
  
  override async openSimpleEmailPreview() {
    let y = this;
    await this.brandingService.generateEmailOrganisation(this.organisation.guid, this.email)
    .then(data => {
      lastValueFrom(data).then(async (template: string) => {
        template = template.replace("[[BodyStart]]", "").replace("[[BodyEnd]]", "");
        await y.openEmailPreview(template);
      })
        .catch(error => this.loggingService.logException(error));
      })
    .catch(error => this.loggingService.logException(error));
  }

  override enableAdvancedEmailMode(event: any) {
    this.advancedEmailMode = (event.target as HTMLInputElement).checked;
    this.email.EmailAdvancedMode = this.advancedEmailMode;
    this.brandingService.setAdvancedModeOrganisation(this._organisation.guid, this.advancedEmailMode.toString())
      .then(value => lastValueFrom(value).catch((error) => this.loggingService.logException(error)))
      .catch((error) => this.loggingService.logException(error));
  }
}

@Component({
  selector: 'app-branding-tab-email-whitelabel',
  templateUrl: './branding-tab-email.component.html'
})
export class BrandingTabEmailWhitelabelComponent extends BrandingTabEmailComponent {
  
  private _whiteLabel!: any;
  get whiteLabel(): any {
    return this._whiteLabel;
  }
  @Input('whiteLabel') set whiteLabel(val: any){
    this._whiteLabel = val;
    if(this._whiteLabel){
      this.getEmail();
    }
  }
  
  constructor(protected override brandingService: IdentityBrandingService, protected override toastService: ToastService, protected override modalService: NgbModal, protected override translateService: TranslateService, protected override loggingService: LoggingService, protected override sanitizer: DomSanitizer) {
    super(brandingService, toastService, modalService, translateService, loggingService, sanitizer)
  }

  private getEmail() {
    this.brandingService.getEmailWhiteLabel(this.whiteLabel.guid)
      .then(value => {
        lastValueFrom(value).then((result: any) => {
          this.email = result;
          this.advancedEmailMode = JSON.parse(result.emailAdvancedMode) ?? false;
          this.email.EmailAdvancedMode = this.advancedEmailMode;
          this.email.emailLogo = result.emailLogoUrl;
          if(!this.email.emailAlignment) this.email.emailAlignment = "Left"
        }).catch((error) => this.loggingService.logException(error));
      })
      .catch((error) => this.loggingService.logException(error));
  }

  protected override async saveImage() {
    const uploadData = new FormData();
    if(this.emailLogo !== null) uploadData.append('EmailLogo', this.emailLogo, this.emailLogoName!);
    uploadData.append('ResetEmailLogo', this.resetEmailLogo.toString());
    this.brandingService.postBrandingWhiteLabel(this.whiteLabel.guid, uploadData)
    .then(data => {
      lastValueFrom(data).then(async () => {
        this.resetEmailLogo = false;
        this.emailLogo = null;
        await this.updateEmail();
      })
      .catch(() => {
        this.toastService.showError("" + this.translations.error + "", "" + this.translations.toastsEmailTemplateErrorSettingLogo + "");
      });
    })
    .catch(error => this.loggingService.logException(error));
  }

  override removeImage() {
    this.emailLogoName = null;
    this.email.emailLogoUrl = null;
    this.resetEmailLogo = true;
    this.emailLogo = null;
    this.brandingChanged = true;
    const uploadData = new FormData();
    uploadData.append('ResetEmailLogo', this.resetEmailLogo.toString());
    this.brandingService.postBrandingWhiteLabel(this.whiteLabel.guid, uploadData)
    .then(data => {
      lastValueFrom(data).then(() => {
        this.resetEmailLogo = false;
        this.brandingChanged = false;
        this.emailLogo = null;
        this.toastService.showSuccess(this.translations.toastSaved, this.translations.toastChangedSaved);
        this.getEmail();
      })
      .catch(() => {
        this.toastService.showError("" + this.translations.error + "", "" + this.translations.toastsErrorDeletingBranding + "");
      });
    });
  }

  protected async updateEmail(){
    this.brandingService.postEmailWhiteLabel(this.whiteLabel.guid, this.email)
      .then(value => lastValueFrom(value).then(() => {
        this.toastService.showSuccess(this.translations.toastSaved, this.translations.toastChangedSaved);
        this.getEmail();
      }).catch((error) => this.loggingService.logException(error)))
      .catch((error) => this.loggingService.logException(error));
  }

  override async updateAdvancedEmail(){
    this.brandingService.postEmailWhiteLabel(this.whiteLabel.guid,this.email)
      .then(value => lastValueFrom(value).then(() => {
        this.toastService.showSuccess(this.translations.toastSaved, this.translations.toastChangedSaved);
        this.getEmail();
      }).catch((error) => this.loggingService.logException(error)))
      .catch((error) => this.loggingService.logException(error));
  }

  override sendTestEmail(){
    this.brandingService.sendTestEmailWhiteLabel(this.whiteLabel.guid, this.email)
    .then(value => 
      lastValueFrom(value))
      .then(() => {
        this.toastService.showSuccess(this.translations.success, this.translations.testEmailSuccessfullySent + " " + this.user.email);
      })
    .catch((error) => this.loggingService.logException(error));
  }
  
  override async openAdvancedEmailPreview() {
    let y = this;
    await this.brandingService.generateEmailWhiteLabel(this.whiteLabel.guid, this.email)
    .then(data => {
      lastValueFrom(data).then(async (template: string) => {
        let emailbody = template.substring(template.indexOf("[[BodyStart]]") + 13, template.lastIndexOf("[[BodyEnd]]"));
        template = this.email.emailHeader + emailbody + this.email.emailFooter;
        await y.openEmailPreview(template);
      })
        .catch(error => this.loggingService.logException(error));
      })
    .catch(error => this.loggingService.logException(error));
  }
  
  override async openSimpleEmailPreview() {
    let y = this;
    await this.brandingService.generateEmailWhiteLabel(this.whiteLabel.guid, this.email)
    .then(data => {
      lastValueFrom(data).then(async (template: string) => {
        template = template.replace("[[BodyStart]]", "").replace("[[BodyEnd]]", "");
        await y.openEmailPreview(template);
      })
        .catch(error => this.loggingService.logException(error));
      })
    .catch(error => this.loggingService.logException(error));
  }

  override enableAdvancedEmailMode(event: any) {
    this.advancedEmailMode = (event.target as HTMLInputElement).checked;
    this.email.EmailAdvancedMode = this.advancedEmailMode;
    this.brandingService.setAdvancedModeWhiteLabel(this.whiteLabel.guid, this.advancedEmailMode.toString())
      .then(value => lastValueFrom(value).catch((error) => this.loggingService.logException(error)))
      .catch((error) => this.loggingService.logException(error));
  }
}

@Component({
  selector: 'app-branding-tab-email-system',
  templateUrl: './branding-tab-email.component.html'
})
export class BrandingTabEmailSystemComponent extends BrandingTabEmailComponent {
  
  private _system!: any;
  get system(): any {
    return this._system;
  }
  @Input('system') set system(val: any){
    this._system = val;
    if(this._system){
      this.getEmail();
    }
  }
  
  constructor(protected override brandingService: IdentityBrandingService, protected override toastService: ToastService, protected override modalService: NgbModal, protected override translateService: TranslateService, protected override loggingService: LoggingService, protected override sanitizer: DomSanitizer) {
    super(brandingService, toastService, modalService, translateService, loggingService, sanitizer)
  }

  private getEmail() {
    this.brandingService.getEmailSystem(this.system.guid)
      .then(value => {
        lastValueFrom(value).then((result: any) => {
          this.email = result;
          this.advancedEmailMode = JSON.parse(result.emailAdvancedMode) ?? false;
          this.email.EmailAdvancedMode = this.advancedEmailMode;
          this.email.emailLogo = result.emailLogoUrl;
          if(!this.email.emailAlignment) this.email.emailAlignment = "Left"
        }).catch((error) => this.loggingService.logException(error));
      })
      .catch((error) => this.loggingService.logException(error));
  }

  protected override async saveImage() {
    const uploadData = new FormData();
    if(this.emailLogo !== null) uploadData.append('EmailLogo', this.emailLogo, this.emailLogoName!);
    uploadData.append('ResetEmailLogo', this.resetEmailLogo.toString());
    this.brandingService.postBrandingSystem(this.system.guid, uploadData)
    .then(data => {
      lastValueFrom(data).then(async () => {
        this.resetEmailLogo = false;
        this.emailLogo = null;
        await this.updateEmail();
      })
      .catch(() => {
        this.toastService.showError("" + this.translations.error + "", "" + this.translations.toastsEmailTemplateErrorSettingLogo + "");
      });
    })
    .catch(error => this.loggingService.logException(error));
  }

  override removeImage() {
    this.emailLogoName = null;
    this.email.emailLogoUrl = null;
    this.resetEmailLogo = true;
    this.emailLogo = null;
    this.brandingChanged = true;
    const uploadData = new FormData();
    uploadData.append('ResetEmailLogo', this.resetEmailLogo.toString());
    this.brandingService.postBrandingSystem(this.system.guid, uploadData)
    .then(data => {
      lastValueFrom(data).then(() => {
        this.resetEmailLogo = false;
        this.brandingChanged = false;
        this.emailLogo = null;
        this.toastService.showSuccess(this.translations.toastSaved, this.translations.toastChangedSaved);
        this.getEmail();
      })
      .catch(() => {
        this.toastService.showError("" + this.translations.error + "", "" + this.translations.toastsErrorDeletingBranding + "");
      });
    });
  }

  protected async updateEmail(){
    this.brandingService.postEmailSystem(this.system.guid, this.email)
      .then(value => lastValueFrom(value).then(() => {
        this.toastService.showSuccess(this.translations.toastSaved, this.translations.toastChangedSaved);
        this.getEmail();
      }).catch((error) => this.loggingService.logException(error)))
      .catch((error) => this.loggingService.logException(error));
  }

  override async updateAdvancedEmail(){
    this.brandingService.postEmailSystem(this.system.guid,this.email)
      .then(value => lastValueFrom(value).then(() => {
        this.toastService.showSuccess(this.translations.toastSaved, this.translations.toastChangedSaved);
        this.getEmail();
      }).catch((error) => this.loggingService.logException(error)))
      .catch((error) => this.loggingService.logException(error));
  }

  override sendTestEmail(){
    this.brandingService.sendTestEmailSystem(this.system.guid, this.email)
    .then(value => 
      lastValueFrom(value))
      .then(() => {
        this.toastService.showSuccess(this.translations.success, this.translations.testEmailSuccessfullySent + " " + this.user.email);
      })
    .catch((error) => this.loggingService.logException(error));
  }
  
  override async openAdvancedEmailPreview() {
    let y = this;
    await this.brandingService.generateEmailSystem(this.system.guid, this.email)
    .then(data => {
      lastValueFrom(data).then(async (template: string) => {
        let emailbody = template.substring(template.indexOf("[[BodyStart]]") + 13, template.lastIndexOf("[[BodyEnd]]"));
        template = this.email.emailHeader + emailbody + this.email.emailFooter;
        await y.openEmailPreview(template);
      })
        .catch(error => this.loggingService.logException(error));
      })
    .catch(error => this.loggingService.logException(error));
  }
  
  override async openSimpleEmailPreview() {
    let y = this;
    await this.brandingService.generateEmailSystem(this.system.guid, this.email)
    .then(data => {
      lastValueFrom(data).then(async (template: string) => {
        template = template.replace("[[BodyStart]]", "").replace("[[BodyEnd]]", "");
        await y.openEmailPreview(template);
      })
        .catch(error => this.loggingService.logException(error));
      })
    .catch(error => this.loggingService.logException(error));
  }

  override enableAdvancedEmailMode(event: any) {
    this.advancedEmailMode = (event.target as HTMLInputElement).checked;
    this.email.EmailAdvancedMode = this.advancedEmailMode;
    this.brandingService.setAdvancedModeSystem(this.system.guid, this.advancedEmailMode.toString())
      .then(value => lastValueFrom(value).catch((error) => this.loggingService.logException(error)))
      .catch((error) => this.loggingService.logException(error));
  }
}
